import { Menu } from 'antd';
import PropTypes from 'prop-types';
import { useState } from 'react';

const DashboardTabMenu = ({ children, menuItems }) => {
  const [currentTab, setCurrentTab] = useState('0');

  // Set current tab (Staff or Patient tab)
  const onChangeTab = (e) => {
    setCurrentTab(e.key.toString());
  };

  return (
    <div className="flex flex-wrap green-menu">
      <Menu
        className="w-full justify-around"
        onClick={onChangeTab}
        selectedKeys={[currentTab]}
        mode="horizontal">
        {menuItems.map(({ key, value }) => (
          <Menu.Item key={key}>{value}</Menu.Item>
        ))}
      </Menu>
      <p className="w-full mt-4 text-left m-0 p-0 text-baxterGray">
        {menuItems[currentTab].title}
      </p>
      <div className="w-full h-70">{children[currentTab]}</div>
    </div>
  );
};

/**
 * Component definition of proptypes.
 */
DashboardTabMenu.propTypes = {
  children: PropTypes.array,
  menuItems: PropTypes.array,
  title: PropTypes.string
};

export default DashboardTabMenu;
